import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

const Reload = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path
            d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2
               c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
            fill="currentColor"
            transform="scale(-1,1) translate(-24,0) rotate(-30 12 12)"
        />
    </SvgIcon>
);

export default Reload;
